/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react"

import classNames from "classnames"

import { ColorScheme } from "shared/context/color-scheme/ColorScheme"
import { useOverlayID } from "shared/context/overlay/OverlayIDContext"
import { OverlayStyle } from "shared/context/overlay/types"
import { stopPropagation } from "shared/lib/stopPropagation"

import { getOverlayClassName } from "./getOverlayClassName"

export interface OverlayWrapperProps extends React.HTMLProps<HTMLDivElement> {
  id: string
  headline?: React.ReactNode
  overlayStyle?: OverlayStyle
  theme?: ColorScheme
  children?: React.ReactNode | React.ReactNode[]
  classNamePrefix?: string
  mobileFullscreen?: boolean
  desktopFullscreen?: boolean
}

export const OverlayWrapper = React.memo(
  ({
    id,
    className,
    children,
    overlayStyle,
    theme,
    classNamePrefix,
    mobileFullscreen,
    desktopFullscreen,
    headline,
    ...props
  }: OverlayWrapperProps) => {
    const { containerID, titleID } = useOverlayID(id)

    return (
      <div
        id={containerID}
        className={classNames(
          "overlay-wrapper",
          getOverlayClassName(overlayStyle),
          className,
          { "mobile-fullscreen": mobileFullscreen }
        )}
        data-bs-theme={theme || undefined}
        data-testid={id || "overlay-wrapper"}
        {...props}
      >
        {headline && titleID ? (
          <span id={titleID} className="visually-hidden">
            {headline}
          </span>
        ) : null}
        <div
          className={classNames(
            `overlay-container ${
              getOverlayClassName(overlayStyle) || classNamePrefix
            }__container`,
            { "w-100": desktopFullscreen, "h-100": desktopFullscreen }
          )}
          onMouseDown={stopPropagation}
          onClick={stopPropagation}
        >
          {children}
        </div>
      </div>
    )
  }
)
